/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BuildingGovIcon32Regular = forwardRef('BuildingGovIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M13.158 6.106a4.5 4.5 0 0 1 5.685 0l10.025 8.17a1 1 0 1 0 1.264-1.551l-10.026-8.17a6.5 6.5 0 0 0-8.212 0l-10.026 8.17a1 1 0 1 0 1.264 1.55l10.026-8.169Z" }),
        React.createElement("path", { d: "M8 15a1 1 0 1 0-2 0v9a1 1 0 1 0 2 0v-9Z" }),
        React.createElement("path", { d: "M4 27a1 1 0 1 0 0 2h24a1 1 0 1 0 0-2H4Z" }),
        React.createElement("path", { d: "M13 14a1 1 0 0 1 1 1v9a1 1 0 1 1-2 0v-9a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M20 15a1 1 0 1 0-2 0v9a1 1 0 1 0 2 0v-9Z" }),
        React.createElement("path", { d: "M25 14a1 1 0 0 1 1 1v9a1 1 0 1 1-2 0v-9a1 1 0 0 1 1-1Z" })));
});
